import { ComponentProps, ForwardedRef, forwardRef } from "react"
import { UseFormRegisterReturn } from "react-hook-form"
import { CSSProp, theme } from "../../../../../styles/stitches.config"
import { SInputWrapper, SRightContentWrapper, SSelect } from "../../acquisitionForm/AcquisitionForm.styled"
import { ArrowDown, Check, Cross } from "../../../../../images/xd/icons"
import { FormError } from "./Form"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { Div } from "../../../../../components/div/Div"

export type FormSelectProps<T extends object> = {
  id?: string
  options: T
  defaultValue?: keyof T
  css?: CSSProp
  placeholder?: string
  required?: boolean
  success?: boolean
  error?: string
  formRegisterProps?: UseFormRegisterReturn
  value?: ComponentProps<"select">["value"]
  onChange?: ComponentProps<"select">["onChange"]
  onBlur?: ComponentProps<"select">["onBlur"]
}

function FormSelectInner<T extends object>(props: FormSelectProps<T>, ref: ForwardedRef<HTMLSelectElement>) {
  const {
    id = "select",
    options,
    defaultValue,
    css,
    placeholder,
    required,
    success,
    error,
    formRegisterProps,
    ...field
  } = props

  return (
    <Div>
      <Spacer size={theme.space.s3_5} />

      <SInputWrapper>
        <SSelect
          id={id}
          ref={ref}
          {...field}
          placeholder={placeholder}
          defaultValue={defaultValue?.toString()}
          required={required}
          css={css}
          state={success ? "success" : !!error ? "error" : "default"}
          hasRightContent={success || !!error}
          {...formRegisterProps}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {Object.entries(options).map(([value, name]) => (
            <option key={value} value={value} style={{ color: theme.colors.texts.value }}>
              {name}
            </option>
          ))}
        </SSelect>

        <SRightContentWrapper>
          {success && <Check color={theme.colors.successes.value} width={18} height={18} />}
          {!!error && <Cross color={theme.colors.errors.value} width={18} height={18} />}
          {success === undefined && !error && <ArrowDown color={theme.colors.textsAlt.value} width={24} height={24} />}
        </SRightContentWrapper>
      </SInputWrapper>

      {error && (
        <>
          <Spacer size={theme.space.s1_5} />
          <FormError>{error}</FormError>
        </>
      )}
    </Div>
  )
}

export const FormSelect = forwardRef(FormSelectInner)
